import React from "react"
import PropTypes from "prop-types"
import { StyledCurrencyValue } from "./styles"

const PlainCell = ({ value, type, column, simpleForm }) => {
  let truncate = false
  if (type === "currency" && simpleForm) {
    const num = parseFloat((value || "").replace(/[^0-9.-]+/g, ""))
    return <StyledCurrencyValue positive={isNaN(num) ? false : num >= 0}>{value}</StyledCurrencyValue>
  } else {
    truncate = column?.truncate && value?.length > column.truncate
  }
  return truncate ? <span title={value}>{value.slice(0, column.truncate)}...</span> : value
}

PlainCell.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  column: PropTypes.shape({
    truncate: PropTypes.number
  }),
  simpleForm: PropTypes.bool
}

PlainCell.defaultProps = {
  value: "",
  type: undefined,
  column: {},
  simpleForm: false
}

export default PlainCell
